import Space from '../../assets/img/space.png';

const Error = () => {
    const refreshPage = () => {
        window.location.reload();
      }

    return (
        <div className="container">
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="row">
                    <div className="col">
                        <img className="mx-auto d-block" style={{ height: 150, width: 'auto' }} src={Space} alt="You are Offline" />
                        <p className="text-center mt-3">Ups, it seems like you have no internet connection.</p>
                        <div className="d-grid gap-2 col-4 mx-auto">
                            <button className="btn btn-outline-danger" onClick={refreshPage}>Refresh</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Error
